import React, {useState,  useRef, useEffect } from 'react';
import '../styles/DataDocument.css';

const DataDocument = ({
  nombre,
  peso,
  idioma,
  fecha,
  contenido
}) => {
  const [showFullText, setShowFullText] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);
  
  const maxCharCount = 150;
  const initialHeight = 200;

  const handleToggleText = () => {
    setShowFullText(!showFullText);
  };
  
  useEffect(() => {
    if (showFullText) {
      contentRef.current.style.height = `${contentRef.current.scrollHeight}px`;
    } else {
      contentRef.current.style.height = `${initialHeight}px`;
    }
  }, [showFullText]);


  return (
    <div className="data-document" ref={contentRef}>
      <h2>Acerca de este documento:</h2>
      <div className="document-details">
        <div className="document-row">
          <span className="label">Nombre:</span>
          <span>{nombre}</span>
        </div>
        <div className="document-row">
          <span className="label">Fecha de Modificación:</span>
          <span>{fecha}</span>
        </div>
        <div className="document-row">
          <span className="label">Peso:</span>
          <span>{peso}</span>
        </div>
        <div className="document-row">
          <span className="label">Idioma:</span>
          <span>{idioma}</span>
        </div>
        <div className="document-row">
          <span className="label">Texto:</span>
          <span id = "content" ref={contentRef}>
            {showFullText ? contenido : `${contenido.substring(0, maxCharCount)}...`}
            {contenido.length > maxCharCount && (
              <button className="toggle-text-button" onClick={handleToggleText}>
                {showFullText ? " Ver menos" : " Ver más"}
              </button>
            )}
          </span>
        </div>

      </div>
    </div>
  );
};

export default DataDocument;
